import React, { useState } from 'react'; 
import UnifiedGallery from '../components/UnifiedGallery';
import useStandardGallery from '../hooks/useStandardGallery';

const TomatoJarsPage = () => {
  // Use standardized gallery hook with consistent configuration
  //const { getGalleryProps } = useStandardGallery('tomatoes');
  const { getGalleryProps, loading, error, photos, refreshPhotos } = useStandardGallery('tomatoes', {
    // FEATURES CONFIGURATION
    features: {
      slideshow: true,              // Enable slideshow functionality
      thumbnails: true,             // Show thumbnail navigation
      fullscreen: true,             // Enable fullscreen mode
      zoom: true,                   // Enable zoom functionality
      captions: true,               // Show photo captions
      sharing: false,               // Enable sharing buttons (default: false)
      
      // PERFORMANCE FEATURES
      lazyLoading: true,            // Enable lazy loading for better performance
      imageOptimization: true,      // Enable image optimization
      preloadAdjacent: 2            // Number of adjacent images to preload (2 on each side)
    },
    
    // LAYOUT CONFIGURATION
    layout: {
      thumbnailSize: 220,           // Size of thumbnails in pixels
      maxDisplay: null,             // Maximum number of photos to display (null = all)
      columns: 'auto',              // Number of columns: 'auto', 1, 2, 3, 4, etc.
      spacing: 'default'            // Spacing between photos: 'compact', 'default', 'wide'
    },
    
    // PERFORMANCE CONFIGURATION
    performance: {
      enableIntersectionObserver: true,    // Use Intersection Observer for performance
      rootMargin: 50,                      // Root margin for Intersection Observer (pixels)
      enableWebP: true,                    // Enable WebP format support
      enableProgressiveLoading: true       // Enable progressive image loading
    }
  });

  return (
      <div className="page-container-wrapper max-width-default padding-default">
        <div className="page-header">
          <h1>
            <i className="fas fa-leaf"></i>
            Tomato Jars
          </h1>
          <p>Growing, cooking, and enjoying the perfect tomato</p>
        </div>
        
        <div className="page-content">
          <div className="section">
            <p>
              Welcome to our tomatoes section! Discover everything about growing, selecting, and cooking with tomatoes. 
              From sweet cherry varieties to meaty Roma tomatoes, explore the world of this versatile garden staple.
            </p>
          </div>
      
        {/* Tomato Jars Gallery */}
        <div className="section">
          <UnifiedGallery 
            {...getGalleryProps("Tomato Jars")}
          />
        </div>           
          </div>
        </div>
  );
};

export default TomatoJarsPage;